import { useSelector } from 'react-redux'

import { getSelectedAgent } from '@/reducers/voiceAgents/voiceAgents.helpers'

import { useAgentIdentifiers } from './useAgentIdentifiers'
import { buildFullName } from '../agentNameHelpers'

// The name the open agent is called, resolved once for every surface that
// labels it: the header, the rename form, the call screen and the outbound-call
// modal. They used to split — the header on the config `title`, the list on the
// owner's name — which meant a rename (AVR-827) showed in one place and not the
// others.
//
// Precedence matches `resolveAgentName` for the roster: the agent's own
// ai-agent user name first, because that is the half a rename writes, then the
// config title, then the identifiers that are never blank so a loaded agent
// always renders something. `slug` is last and deliberately included — it is
// the only one available on the legacy `/voice-agents/:agentId` route, where no
// provisioning record resolves.
export const useAgentDisplayName = () => {
  const agent = useSelector((state) => getSelectedAgent(state.voiceAgents))
  const selectedAgentId = useSelector((state) => state.voiceAgents.selectedAgentId)
  const { ownerFirstName, ownerLastName, slug } = useAgentIdentifiers()

  const ownerName = buildFullName(ownerFirstName, ownerLastName)
  return {
    // What to show. Falls through to the PE agent id rather than returning
    // nothing, so no surface renders an unlabelled agent.
    displayName: ownerName || agent?.title || slug || selectedAgentId || '',
    // What the rename form edits — the stored halves only, with no fallback.
    // A config title is not this agent's name to overwrite, and seeding the
    // form with one would turn opening the form into a rename.
    ownerName,
  }
}
